import { useEffect, useState } from 'react';

import {
  ENRICHMENT_POLL_MS,
  isEnrichmentInProgress,
} from '@/utils/propertyEnrichment';
import type { Product } from '@/types/ProductType';

/**
 * True while any of `products` is still being enriched. Re-checks on a timer
 * so the time-based cutoffs expire even when refetches return unchanged data.
 */
export function useEnrichmentWatch(
  products: ReadonlyArray<Product | undefined> | undefined
): boolean {
  const [now, setNow] = useState(() => Date.now());
  const active = Boolean(products?.some((p) => isEnrichmentInProgress(p, now)));
  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => setNow(Date.now()), ENRICHMENT_POLL_MS);
    return () => clearInterval(id);
  }, [active]);
  return active;
}
